/* eslint-disable react/no-unescaped-entities */
import HTTPsImg from "../../assets/kb/HTTPs.jpg";
import JWTImg from "../../assets/kb/JWT.jpg";

const TechnicalBackground = () => {
  return (
    <div>
      <h2 className="font-bold text-bluePrimary">
        Technical Background of the Smart Pay Application
      </h2>
      <div className="my-4">
        <h4 className="font-bold md:text-xl mb-3">Introduction</h4>
        <p>
          The Smart Pay application is constructed with a sophisticated
          technical architecture, comprising three interconnected elements: the
          Mobile Application, the Front-End Website, and a set of structured
          APIs supported by a robust database. This comprehensive approach
          ensures a seamless user experience across diverse platforms while
          harnessing advanced technologies to uphold modern security standards.
        </p>
      </div>
      <div className="my-4">
        <h4 className="font-bold mb-3">1. Mobile Application</h4>
        <p>
          The mobile application facet of Smart Pay is meticulously developed
          using a strategic blend of technologies that prioritize performance
          and user engagement. The application is crafted using the{" "}
          <strong>React Native</strong> framework, enabling it to be seamlessly
          cross-platform, guaranteeing a consistent user experience across both
          iOS and Android devices. React Native's component-driven architecture
          empowers developers to craft dynamic, responsive, and engaging user
          interfaces.
        </p>
      </div>
      <div className="my-4">
        <h4 className="font-bold mb-3">2. Front-End Website</h4>
        <p>
          he Smart Pay front-end website is skillfully engineered with the{" "}
          <strong>React</strong> JavaScript library. React's inherent
          flexibility allows developers to craft interactive and adaptive user
          interfaces through modular, reusable components. This choice ensures a
          smooth, intuitive user interaction for individuals accessing Smart Pay
          through web browsers, effectively mirroring the capabilities of the
          mobile application.
        </p>
      </div>
      <div className="my-4">
        <h4 className="font-bold mb-3">3. API with Structured Database</h4>
        <p className="mb-3">
          Central to Smart Pay's operation is a well-designed set of structured
          APIs, acting as a vital link between user interfaces and the
          underlying database. Developed using <strong>Microsoft .NET</strong>{" "}
          and <strong>C#</strong>, these APIs facilitate seamless communication,
          data retrieval, and updates. By opting for .NET and C#, Smart Pay
          achieves robustness and scalability, enabling efficient handling of
          user requests and data transactions.
        </p>
        <p>
          At the core of the application, the structured database is powered by{" "}
          <strong>SQL Server</strong>, serving as a foundation for data
          integrity, security, and reliable data storage. SQL Server's
          relational database management capabilities ensure organized storage
          and retrieval of crucial data elements, including user information and
          transaction records.
        </p>
      </div>
      <h2 className="font-bold text-bluePrimary md:text-xl">Security Standards</h2>
      <div className="my-4">
        <p>
          Smart Pay is uncompromising in its dedication to security, implemented
          through several comprehensive measures:
        </p>
        <ul className="list-disc w-full my-2">
          <li>
            <strong>HTTPS (Hypertext Transfer Protocol Secure):</strong> All
            communication between users and the application is fortified with
            HTTPS, encrypting data during transmission and thwarting
            unauthorized access to sensitive information.
            <div className="d-flex justify-content-center">
              <img src={HTTPsImg} alt="https" className="w-100"/>
            </div>
          </li>
          <li>
            <strong>JWT Authorization (JSON Web Tokens):</strong> Smart Pay
            employs JWT for robust authorization and authentication. This
            industry-standard practice enables users to access designated
            functionalities confidently, while unauthorized access attempts are
            thwarted.
            <div className="d-flex justify-content-center">
              <img src={JWTImg} alt="JWT"  className="w-100"/>
            </div>
          </li>
          <li>
            <strong>TLS 1.2 and 1.3 (Transport Layer Security):</strong> Smart
            Pay adopts TLS protocols 1.2 and 1.3 to establish secure connections
            between users and the server, encrypting data transmission and
            mitigating the risk of eavesdropping and tampering.
          </li>
        </ul>
      </div>
      <h2 className="font-bold text-bluePrimary md:text-xl mb-3">
        Secure Code Management
      </h2>
      <p className="mb-4">
        Smart Pay's codebase is meticulously managed within a secure environment
        on <strong>GitHub</strong>, a widely recognized and trusted platform for
        version control and collaborative software development. This ensures the
        code's integrity, version history, and collaborative enhancements are
        securely managed.
      </p>
      <h2 className="font-bold text-bluePrimary mb-3 md:text-xl">
        Personal Information Security
      </h2>
      <p>
        In line with stringent data protection practices, sensitive user
        information such as Email, Password, and PIN is stored with the highest
        degree of security. Smart Pay employs the <strong>SHA-256</strong>{" "}
        encryption algorithm to secure this data, rendering it virtually
        irreversible. This cryptographic technique ensures that even in the
        unlikely event of data exposure, personal information remains
        safeguarded against unauthorized access.
      </p>
    </div>
  );
};

export default TechnicalBackground;
